import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import Header from './Header.js';
import Footer from './Footer.js';
import NewsletterSubscription from './NewsletterSubscription.js';
import { fullUrl } from './utils/url';
import Picture from './components/Picture.jsx';

const quickContacts = [
  {
    title: 'Adicionar aos contatos',
    variant: 'red',
    content: (
      <>
        <p className="text-base font-semibold text-white">Salve a Gtechniq Brasil</p>
        <p className="text-white/90">Baixe o vCard oficial para ter telefone, e-mail e WhatsApp sempre à mão.</p>
        <a
          href={fullUrl('/assets/gtechniq-brasil.vcf')}
          className="inline-flex items-center font-semibold uppercase tracking-wide text-xs bg-white text-[#FF0000] px-4 py-2"
        >
          Baixar cartão de contato
        </a>
      </>
    )
  },
  {
    title: 'Contato rápido',
    variant: 'white',
    content: (
      <>
        <div>
          <p className="font-semibold uppercase tracking-wide text-gray-900">WhatsApp</p>
          <a
            href="https://wa.me/5561992543830?text=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20produtos%20Gtechniq"
            className="text-[#FF0000] font-semibold hover:text-red-700"
            target="_blank"
            rel="noreferrer"
          >
            Fale conosco pelo WhatsApp
          </a>
        </div>
        <div>
          <p className="font-semibold uppercase tracking-wide text-gray-900">E-mail</p>
          <a href="mailto:contato@gtechniq.com.br" className="text-[#FF0000] font-semibold hover:text-red-700">
            contato@gtechniq.com.br
          </a>
        </div>
        <p className="text-xs text-gray-500">
          Atendimento de segunda a sexta, das 9h às 18h.
        </p>
      </>
    )
  },
  {
    title: 'Rede credenciada',
    variant: 'black',
    content: (
      <>
        <p>Quer encontrar um aplicador credenciado perto de você? Acesse o mapa oficial e veja quem atende a sua região.</p>
        <Link
          to="/encontre-um-profissional"
          className="inline-flex items-center justify-center bg-white text-[#0F172A] px-4 py-2 font-semibold tracking-wide uppercase text-xs hover:bg-gray-100 transition"
        >
          Quero encontrar um aplicador
        </Link>
      </>
    )
  }
];

const faqItems = [
  {
    question: 'Onde posso comprar os produtos Gtechniq no Brasil?',
    answer: (
      <>
        Você pode comprar na <a href="https://gtechniq.com.br/loja" className="text-[#FF0000] font-semibold hover:text-red-700" target="_blank" rel="noreferrer">loja oficial</a>, com revendedores autorizados listados no nosso site e também pelo WhatsApp <a href="https://wa.me/5561992543830" className="text-[#FF0000] font-semibold hover:text-red-700" target="_blank" rel="noreferrer">(61) 99254‑3830</a>. Enviamos para todo o Brasil.
      </>
    )
  },
  {
    question: 'Como saber se o produto é original?',
    answer: (
      <>
        Para garantir a autenticidade, prefira sempre a <a href="https://gtechniq.com.br/loja" className="text-[#FF0000] font-semibold hover:text-red-700" target="_blank" rel="noreferrer">loja oficial</a> ou revendedores autorizados listados em nossos canais. Na hora da compra, confira se a embalagem possui lacres de segurança e a identidade visual oficial da Gtechniq.
        <br />
        Evite adquirir produtos de terceiros ou em marketplaces (Shopee, AliExpress, Mercado Livre etc.). A única exceção é a nossa loja oficial na Amazon; fora dela há alta incidência de falsificações.
        <br />
        Todos os produtos Gtechniq são fabricados no Reino Unido, exclusivamente pela própria marca. Qualquer pessoa ou empresa que afirme “fabricar” Gtechniq está agindo de má‑fé.
        <br />
        Ficou em dúvida? Fale conosco pelo formulário ou WhatsApp e verificamos para você.
      </>
    )
  },
  {
    question: 'A Gtechniq só atende profissionais ou também consumidores finais?',
    answer: (
      <>
        Atendemos profissionais e consumidores finais. Os produtos da marcão são de venda aberta, já o <strong>Crystal Serum Ultra</strong> é de venda exclusiva para a rede de <strong>Aplicadores Oficiais (Accredited Detailer)</strong>.
      </>
    )
  },
  {
    question: 'Como encontro um instalador / Accredited Detailer autorizado pela Gtechniq?',
    answer: (
      <>
        Use o nosso <Link to="/encontre-um-profissional" className="text-[#FF0000] font-semibold hover:text-red-700">localizador de profissionais</Link>. Em caso de dúvidas, fale pelo formulário desta página ou pelo WhatsApp. Se preferir indicação, preencha o formulário que indicamos um aplicador.
      </>
    )
  },
  {
    question: 'Posso revender ou ser parceiro da Gtechniq?',
    answer: (
      <>
        Sim. Lojas, detailers, representantes comerciais e estéticas automotivas podem revender. Requisito básico: <strong>compra mínima</strong> e atuação na venda de produtos. Para iniciar, use o formulário desta página ou o WhatsApp <a href="https://wa.me/5561992543830" className="text-[#FF0000] font-semibold hover:text-red-700" target="_blank" rel="noreferrer">(61) 99254‑3830</a>.
      </>
    )
  },
  {
    question: 'Como verifico se um instalador é Aplicador Oficial (Accredited Detailer) no Brasil?',
    answer: (
      <>
        Consulte a lista oficial em <Link to="/encontre-um-profissional" className="text-[#FF0000] font-semibold hover:text-red-700">gtechniq.com.br/encontre-um-profissional</Link>. Persistindo a dúvida, fale conosco pelo WhatsApp ou pelo formulário para verificarmos.
      </>
    )
  },
  {
    question: 'Vocês oferecem treinamento ou certificação para detailers? Como me inscrevo?',
    answer: (
      <>
        Oferecemos <strong>treinamento</strong> para quem ingressa na rede de aplicadores, presencial (no espaço do ingressante; deslocamento e estadia por conta do ingressante) ou online. Também realizamos <strong>workshops</strong> abertos esporadicamente. Para se inscrever, acesse a página de ingresso (<Link to="/seja-um-aplicador-oficial" className="text-[#FF0000] font-semibold hover:text-red-700">gtechniq.com.br/seja-um-aplicador-oficial</Link>) ou fale pelo formulário/WhatsApp.
      </>
    )
  },
  {
    question: 'Como posso ingressar na rede de Aplicador Oficial (Accredited Detailer)?',
    answer: (
      <>
        Acesse <Link to="/seja-um-aplicador-oficial" className="text-[#FF0000] font-semibold hover:text-red-700">gtechniq.com.br/seja-um-aplicador-oficial</Link> e preencha o formulário. Lá você encontra critérios, etapas e próximos passos; nossa equipe fará o contato.
      </>
    )
  },
  {
    question: 'Existe política comercial específica para lojistas e profissionais do ramo?',
    answer: (
      <>
        Sim. Oferecemos <strong>condições diferenciadas</strong> para lojistas, empresas e profissionais. Solicite sua proposta via formulário desta página ou WhatsApp <a href="https://wa.me/5561992543830" className="text-[#FF0000] font-semibold hover:text-red-700" target="_blank" rel="noreferrer">(61) 99254‑3830</a>.
      </>
    )
  }
];

const initialFormState = {
  nome: '',
  empresa: '',
  email: '',
  telefone: '',
  assunto: 'Informações comerciais',
  mensagem: ''
};

const ContactPage = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [formStatus, setFormStatus] = useState('idle');
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [captchaError, setCaptchaError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const captchaRef = useRef(null);
  // Always post to the hosted API, allowing overrides via env when needed.
  const CONTACT_ENDPOINT = process.env.REACT_APP_CONTACT_ENDPOINT
    || '/api/contact-submit.php';

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'telefone') {
      const digits = value.replace(/\D/g, '').slice(0, 11);
      let masked = digits;
      if (digits.length > 10) {
        masked = digits
          .replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
      } else if (digits.length > 6) {
        masked = digits
          .replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
      } else if (digits.length > 2) {
        masked = digits
          .replace(/^(\d{2})(\d{0,5}).*/, '($1) $2');
      } else if (digits.length > 0) {
        masked = digits.replace(/^(\d{0,2}).*/, '($1');
      }
      setFormData((prev) => ({
        ...prev,
        [name]: masked
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
    setFormErrors((prev) => ({
      ...prev,
      [name]: undefined
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setCaptchaError(false);

    // Validate phone before sending
    const phoneDigits = (formData.telefone || '').replace(/\D/g, '');
    const phoneValid = phoneDigits.length === 10 || phoneDigits.length === 11;
    if (!phoneValid) {
      setFormErrors((prev) => ({
        ...prev,
        telefone: 'Informe um telefone válido com DDD.'
      }));
      setIsSubmitting(false);
      return;
    }
    const token = captchaRef.current?.getValue();
    if (token) {
      finalizeSubmission(token);
    } else {
      captchaRef.current?.execute();
    }
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex((current) => (current === index ? null : index));
  };

  const finalizeSubmission = async (token) => {
    if (!token) {
      setCaptchaError(true);
      setIsSubmitting(false);
      return;
    }
    setCaptchaError(false);
    const payload = {
      nome: formData.nome,
      empresa: formData.empresa,
      email: formData.email,
      telefone: formData.telefone,
      assunto: formData.assunto,
      mensagem: formData.mensagem,
      token
    };

    try {
      const response = await fetch(CONTACT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      let result = {};
      try {
        result = await response.json();
      } catch (error) {
        // no json body
      }

      if (!response.ok || result.ok === false) {
        throw new Error(result.error || `HTTP ${response.status}`);
      }

      setFormStatus('success');
      setFormData(initialFormState);
    } catch (error) {
      console.error('Failed to submit contact form', error);
      setFormStatus('error');
    } finally {
      captchaRef.current?.reset();
      setIsSubmitting(false);
    }
  };

  const handleCaptchaError = () => {
    setCaptchaError(true);
    setIsSubmitting(false);
  };

  return (
    <div className="font-bai-jamjuree text-gray-800 bg-white">
      <Header />
      <main>
        <section className="relative h-[70vh] flex items-end text-white overflow-hidden pb-32">
          <div className="absolute inset-0" aria-hidden="true">
            <Picture
              src="/images/background/paint-protection-image-min-1-scaled.webp"
              fallbackExt="png"
              alt=""
              pictureClassName="block h-full w-full"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/50" />
          <div className="container mx-auto px-4 md:px-10 relative z-10 w-full">
            <div className="max-w-3xl py-24 md:py-32">
              <span className="inline-block uppercase tracking-[0.35em] text-xs md:text-sm text-[#FF0000] font-semibold mb-4">
                Contato Oficial
              </span>
              <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-6">
                Conecte-se com a Gtechniq Brasil
              </h1>
              <p className="text-base md:text-lg text-gray-200 max-w-2xl">
                Suporte dedicado para aplicadores credenciados, centros de estética automotiva, revendas e entusiastas. Escolha o canal adequado ou envie sua mensagem pelo formulário abaixo.
              </p>
            </div>
          </div>
        </section>

        <section className="relative z-10 -mt-28 md:-mt-40 mb-8">
          <div className="container mx-auto px-4 md:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <div className="bg-white border border-gray-200 shadow-2xl overflow-hidden">
                  <div className="border-b border-gray-200 px-8 py-6">
                    <h2 className="text-2xl font-semibold text-gray-900">Complete o formulário abaixo</h2>
                    <p className="text-sm text-gray-500 mt-2">
                      Envie dúvidas, orçamentos ou propostas de parceria. Direcionamos automaticamente para o especialista responsável.
                    </p>
                  </div>
                  <form className="px-8 py-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label htmlFor="nome" className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
                          Nome completo
                        </label>
                        <input
                          id="nome"
                          name="nome"
                          type="text"
                          required
                          value={formData.nome}
                          onChange={handleChange}
                          className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                          placeholder="Nome e Sobrenome"
                        />
                      </div>
                      <div>
                        <label htmlFor="empresa" className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
                          Empresa / Estúdio
                        </label>
                        <input
                          id="empresa"
                          name="empresa"
                          type="text"
                          value={formData.empresa}
                          onChange={handleChange}
                          className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                          placeholder="Informe se representa um negócio"
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label htmlFor="email" className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
                          E-mail
                        </label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          required
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                          placeholder="seuemail@empresa.com"
                        />
                      </div>
                      <div>
                        <label htmlFor="telefone" className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
                          Telefone / WhatsApp
                        </label>
                        <input
                          id="telefone"
                          name="telefone"
                          type="tel"
                          value={formData.telefone}
                          onChange={handleChange}
                          required
                          className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                          placeholder="(00) 00000-0000"
                        />
                        {formErrors.telefone && (
                          <p className="text-xs text-red-500 mt-1">
                            {formErrors.telefone}
                          </p>
                        )}
                      </div>
                    </div>
                    <div>
                      <label htmlFor="assunto" className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
                        Assunto
                      </label>
                      <select
                        id="assunto"
                        name="assunto"
                        value={formData.assunto}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                      >
                        <option>Informações comerciais</option>
                        <option>Parcerias e credenciamento</option>
                        <option>Suporte técnico</option>
                        <option>Treinamentos</option>
                        <option>Outros assuntos</option>
                      </select>
                    </div>
                    <div>
                      <label htmlFor="mensagem" className="block text-xs font-semibold uppercase tracking-wide text-gray-600 mb-2">
                        Mensagem
                      </label>
                      <textarea
                        id="mensagem"
                        name="mensagem"
                        required
                        rows="6"
                        value={formData.mensagem}
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF0000]"
                        placeholder="Conte mais sobre sua necessidade ou projeto"
                      />
                    </div>
                    <div className="space-y-4 flex flex-col items-center">
                      <button
                        type="submit"
                        className="w-full bg-[#FF0000] text-white font-semibold py-3 uppercase tracking-wide hover:bg-red-700 transition"
                      >
                        {isSubmitting ? 'Validando...' : 'Enviar mensagem'}
                      </button>
                      <ReCAPTCHA
                        ref={captchaRef}
                        size="invisible"
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
                        onChange={finalizeSubmission}
                        onErrored={handleCaptchaError}
                        onExpired={handleCaptchaError}
                      />
                      {captchaError && (
                        <p className="text-xs text-red-500 text-center">
                          Confirme o captcha antes de enviar.
                        </p>
                      )}
                      {formStatus === 'success' && (
                        <p className="text-xs text-green-600 text-center">
                          Mensagem registrada! Em breve entraremos em contato.
                        </p>
                      )}
                      {formStatus === 'error' && (
                        <p className="text-xs text-red-500 text-center">
                          Não foi possível enviar sua mensagem. Tente novamente em instantes ou fale conosco pelos outros canais.
                        </p>
                      )}
                      <p className="text-[11px] text-gray-500 leading-relaxed text-center">
                        Ao enviar você concorda em receber comunicações da Gtechniq Brasil.
                      </p>
                    </div>
                  </form>
                </div>
              </div>
              <aside className="space-y-6">
                {quickContacts.map((card) => {
                  const variant = card.variant || 'white';
                  const variantStyles = {
                    red: {
                      wrapper: 'bg-[#FF0000] text-white',
                      heading: 'text-white',
                      content: 'text-white/80'
                    },
                    black: {
                      wrapper: 'bg-[#0B0F1F] dark:bg-[#232324] text-white',
                      heading: 'text-white',
                      content: 'text-white/80'
                    },
                    white: {
                      wrapper: 'bg-white text-gray-900',
                      heading: 'text-gray-900',
                      content: 'text-gray-600'
                    }
                  };
                  const styles = variantStyles[variant] || variantStyles.white;

                  return (
                    <div key={card.title} className={`${styles.wrapper} p-6`}
                    >
                      <h3 className={`text-sm font-semibold uppercase tracking-wide mb-4 ${styles.heading}`}>
                        {card.title}
                      </h3>
                      <div className={`${styles.content} space-y-3 text-sm`}>{card.content}</div>
                    </div>
                  );
                })}
              </aside>
            </div>
          </div>
        </section>

        <section className="bg-gray-50 py-6 mb-8">
          <div className="container mx-auto px-4 md:px-10">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Dúvidas Frequentes</h2>
              <p className="text-gray-600">
                Reunimos dúvidas comuns de detailers, distribuidores e consumidores para agilizar seu atendimento.
              </p>
            </div>
            <div className="max-w-4xl mx-auto divide-y divide-gray-200 border border-gray-200 bg-white">
              {faqItems.map((item, index) => (
                <button
                  key={item.question}
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="w-full text-left px-6 py-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF0000]"
                >
                  <div className="flex items-start justify-between gap-6">
                    <div>
                      <h3 className="text-base font-semibold text-gray-900">{item.question}</h3>
                      {openFaqIndex === index && (
                        <p className="text-[15px] text-gray-600 mt-3 leading-relaxed">{item.answer}</p>
                      )}
                    </div>
                    <span className="text-[#FF0000] text-xl font-semibold">
                      {openFaqIndex === index ? '-' : '+'}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-[#0F172A] dark:bg-[#232324] relative overflow-hidden">
          <div className="absolute inset-y-0 right-0 w-2/5 bg-gradient-to-l from-[#FF0000]/30 to-transparent opacity-80" />
          <div className="absolute inset-0 opacity-10" aria-hidden="true">
            <Picture
              src="/images/background/product-image-about-min.webp"
              fallbackExt="png"
              alt=""
              pictureClassName="block h-full w-full"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-10">
            <div className="text-white space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold leading-tight">
                Faça parte da rede de Aplicadores Oficiais Gtechniq
              </h2>
              <p className="text-gray-200 text-lg max-w-3xl">
                Treinamento, suporte técnico e condições comerciais para quem busca elevar o padrão de proteção automotiva com Revestimentos Cerâmicos de referência. Apresente sua estrutura, serviços e região de atendimento — avaliamos seu perfil e orientamos os próximos passos.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/seja-um-aplicador-oficial"
                  className="inline-flex items-center justify-center px-6 py-3 bg-[#FF0000] hover:bg-red-700 font-semibold tracking-wide uppercase"
                >
                  Quero ser Aplicador Oficial
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <NewsletterSubscription />
      <Footer />
    </div>
  );
};

export default ContactPage;
